<!--认证资料提交-->
<template>
  <div class="container"
       v-loading.body="ifLoading"
  >
    <p class="show"><span class="show-red">温馨提示：</span>带&nbsp;&nbsp;<span class="show-red">*</span>&nbsp;&nbsp;的为必填项
    </p>
    <hint-input
      name="nsrsbh"
      ref="nsrsbh"
      label="社会信用代码"
      placeholder="请输入社会信用代码"
      maxlength="18"
      required
      :readonly="nsrsbhDisabled"
      :value.sync="finalData.nsrsbh"
    ></hint-input>
    <hint-input
      name="qymc"
      ref="qymc"
      label="企业名称"
      placeholder="请输入企业名称"
      maxlength="25"
      required
      :value.sync="finalData.qymc"
    ></hint-input>
    <hint-input
      name="zzdj"
      ref="zzdj"
      label="资质等级"
      placeholder="请输入资质等级"
      maxlength="10"
      required
      :value.sync="finalData.zzdj"
    ></hint-input>

    <div class="marginCon">
      <span class="labelTitle"><span class="redReq">*</span>营业执照副本（加盖红色公章）：</span>
      <a class="upLink businessUp">上传附件</a>
      <div v-if="businessMsgShow" class="showText">
        营业执照副本必须上传
      </div>
    </div>

    <!--营业执照-->
    <div
      v-if="businessFiles.length != 0"
      class="fileCon businessFileCon"
    >
      <div class="viewer" v-viewer="{}">
        <MultiImage
          v-for="(item,index) in businessFiles"
          :src="item.packSrc"
          :key="index"
          :originalSrc="item.orgSrc"
          :loading.sync="item.loading"
          :index="index"
          :adapter="businessFiles"
          @eventCallback="eventCallback"
        ></MultiImage>
      </div>
    </div>

    <div class="applyCon">
      <span class="labelTitle"><span class="redReq">*</span>申请类型：</span>
      <el-radio-group v-model="applyType" @change="applyTypeChange">
        <el-radio label="0">产品试用</el-radio>
        <el-radio label="1">正式授权</el-radio>
      </el-radio-group>
    </div>

    <el-collapse-transition>
      <div v-show="applyType == '1'">
        <hint-input
          name="htbh"
          ref="htbh"
          label="与协同软件签订的合同编号"
          placeholder="请输入合同编号，用于正式授权审核"
          maxlength="100"
          required
          :value.sync="finalData.htbh"
        ></hint-input>

        <div class="marginCon">
          <span class="labelTitle"><span class="redReq">*</span>与协同软件签订的合同附件：</span>
          <a class="upLink contractUp">上传附件</a>
          <div v-if="contractMsgShow" class="showText">
            合同附件必须上传
          </div>
        </div>

        <div
          v-if="contractFiles.length != 0"
          class="fileCon contractFileCon">
          <div class="viewer" v-viewer="{}">
            <MultiImage
              v-for="(item,index) in contractFiles"
              :src="item.packSrc"
              :key="item.id"
              :originalSrc="item.orgSrc"
              :loading.sync="item.loading"
              :index="index"
              :adapter="contractFiles"
              @eventCallback="eventCallback"
            ></MultiImage>
          </div>
        </div>
      </div>
    </el-collapse-transition>

    <div class="commitBtn" @click="commitData">
      提&nbsp;交
    </div>

    <el-dialog
      title="提示"
      :visible.sync="successDialog"
      width="460px"
      :close-on-click-modal="false"
      @close="handleClose"
    >

      <p class="dialogTitle">
        提交成功
      </p>
      <p class="dialogCon">您的{{applyType=='0'?'产品试用':'正式授权'}}申请已提交，我们将于<span class="workDay">3个工作日内</span>进行审核，<br/>审核结果将以短信形式发送，请关注手机信息。
      </p>
    </el-dialog>
  </div>
</template>

<script>
  import HintInput from '@/components/HintInput'
  import MultiImage from '@/components/MultiImage'
  import Upload from '../utils/XTUpload.js'
  import ElCollapseTransition from 'element-ui/lib/transitions/collapse-transition'

  export default {
    name: 'DataCommit',
    data () {
      return {
        businessUpload: Object
        , contractUpload: Object
        // 营业执照集合
        , businessFiles: []
        // 合同附件集合
        , contractFiles: []
        , applyType: '0'
        , curMes: null
        // 先生成个guid
        , guid: this.$utils.randomString()
        // 是否显示营业执照附件提示信息
        , businessMsgShow: false
        // 是否显示合同附件提示信息
        , contractMsgShow: false
        , finalData: {
          // 是否有营业执照
          // yyzhzhfb: '1'
          // // 是否有合同附件
          // , htfj: '1'
          // // 认证状态:正在认证
          // , rzzt: '1'
          // , rz_guid: this.guid
          // , sqlx: this.applyType
          nsrsbh: ''
          , qymc: ''
          , zzdj: ''
          , htbh: ''
        }
        // 提交成功
        , successDialog: false
        // 是否显示转圈圈
        , ifLoading: false
        // 纳税人识别号是否为只读
        , nsrsbhDisabled: false
      }
    }
    , props: {
      common: {
        type: Object
      }
    }
    , methods: {
      // 图片事件返回
      eventCallback (event) {
        console.log(event)
        if (event.type == 'del') {
          let params = {
            id: event.adapter[event.index].id
          }
          this.$axios.get('UserManager/DeleteFujian', {
            params: params
          })
            .then((res) => {
              let data = res.data
              if (data.isError == 'False') {
                event.adapter.splice(event.index, 1)
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
              } else {
                this.$message({
                  type: 'warning',
                  message: '删除失败!'
                })
              }
            })
            .catch((err) => {
              console.log(err)
              this.$message({
                type: 'warning',
                message: '删除失败!'
              })
            })
        }
      }
      // radio 切换监听
      , applyTypeChange (value) {
      }

      // 上传error回调
      , uploadError (msg) {
        this.$message({
          message: msg
          , type: 'warning'
        })
      }

      // 照片处理前的回调
      , uploadBeforeDeal () {
        this.curMes = this.$message({
          message: '图片压缩中...'
        })
      }

      // 营业执照处理完成后的返回
      , businessAfterDeal (curFiles, allFiles) {
        this.curMes && this.curMes.close()
        this.$message({
          message: '图片压缩成功!开始上传...'
          , type: 'success'
        })
        console.log(allFiles)
        this.businessFiles = []
        this.businessFiles = allFiles

        if (this.$store.getters.getUserName == '' || this.$store.getters.getUserName.length == 0) {
          this.$message({
            message: '对不起,您还没有登录!'
            , type: 'warning'
          })
          for (let i = 0; i < this.businessFiles.length; i++) {
            this.businessFiles[i]['loading'] = false
          }
          return
        }

        // 上传图片
        this.goBusinessUpload(curFiles, allFiles)
      }

      // 合同file处理完回调
      , contractAfterDeal (curFiles, allFiles) {
        this.curMes && this.curMes.close()
        this.$message({
          message: '图片压缩成功!开始上传...'
          , type: 'success'
        })
        console.log(allFiles)
        this.contractFiles = []
        this.contractFiles = allFiles

        if (this.$store.getters.getUserName == '' || this.$store.getters.getUserName.length == 0) {
          this.$message({
            message: '对不起,您还没有登录!'
            , type: 'warning'
          })

          for (let i = 0; i < this.contractFiles.length; i++) {
            this.contractFiles[i]['loading'] = false
          }
          return
        }

        // 上传图片
        this.goContractUpload(curFiles, allFiles)
      }

      // 营业执照上传
      , goBusinessUpload (curFiles, allFiles) {
        var fileFormData = this.getFileFormData(curFiles, 0)
        this.$axios.post('RenZhengHandler.ashx', fileFormData)
          .then((res) => {
            let data = res.data
            if (data.isError == 'false') {
              // console.log(allFiles)
              for (let i = allFiles.length - curFiles.length; i < allFiles.length; i++) {
                allFiles[i]['loading'] = false
                allFiles.splice(i, 1, allFiles[i])
              }
              // console.log(this.businessFiles)
              this.$message({
                message: '图片上传成功!'
                , type: 'success'
              })
            } else {
              this.$message({
                message: '图片上传失败,请重试'
                , type: 'warning'
              })
            }
          })
          .catch((err) => {
            this.$message({
              message: '图片上传失败,请重试'
              , type: 'warning'
            })
          })
      }

      // 合同执照上传
      , goContractUpload (curFiles, allFiles) {
        var fileFormData = this.getFileFormData(curFiles, 1)
        this.$axios.post('RenZhengHandler.ashx', fileFormData)
          .then((res) => {
            console.log(res)
            let data = res.data
            if (data.isError == 'false') {
              // console.log(allFiles)
              for (let i = allFiles.length - curFiles.length; i < allFiles.length; i++) {
                allFiles[i]['loading'] = false
                allFiles.splice(i, 1, allFiles[i])
              }
              // console.log(this.businessFiles)
              this.$message({
                message: '图片上传成功!'
                , type: 'success'
              })
            } else {
              this.$message({
                message: '图片上传失败,请重试'
                , type: 'warning'
              })
            }
          })
          .catch((err) => {
            this.$message({
              message: '图片上传失败,请重试'
              , type: 'warning'
            })
          })
      }

      // 网络请求开始提交
      , commitData () {
        // 开始验证必填项
        let ifPass = true

        for (let key in this.finalData) {
          if (this.$utils.trim(this.finalData[key]).length == 0) {
            if (this.applyType == 1 && key == 'htbh') {
              this.$refs[key].blur()
              ifPass = false
            }
            if (key != 'htbh') {
              this.$refs[key].blur()
              ifPass = false
            }
          }
        }
        if (this.applyType == 0 && this.businessFiles.length == 0) {
          this.businessMsgShow = true
          ifPass = false
        }
        if (this.applyType == 1) {
          if (this.businessFiles.length == 0) {
            this.businessMsgShow = true
            ifPass = false
          }
          if (this.contractFiles.length == 0) {
            this.contractMsgShow = true
            ifPass = false
          }
        }
        if (this.$store.getters.getUserName == '' || this.$store.getters.getUserName.length == 0) {
          this.$message({
            message: '对不起,您还没有登录!'
            , type: 'warning'
          })
          ifPass = false
        }
        if (!ifPass) {
          return
        }
        // return

        this.ifLoading = true
        let approveInfo = this.$utils.deepClone(this.finalData)
          , params = {
          info: approveInfo
          , username: this.$store.getters.getUserName
        }
          , url = 'UserManager/RenZheng'

        approveInfo.yyzhzhfb = 1
        approveInfo.htfj = 0
        approveInfo.rzzt = 1
        approveInfo.rz_guid = this.guid
        approveInfo.sqlx = this.applyType
        if (this.applyType == 1) { // 正式授权
          approveInfo.htfj = 1
        }

        // 如果为撤销后的数据
        if (this.common.result.nsrsbh) {
          url = 'UserManager/UpdateRenZheng'
        }

        this.$axios.post(url, params)
          .then((res) => {
            this.ifLoading = false
            let data = res.data
            if (data.isError == 'False') { // 认证成功
              // this.common.step = 1
              this.$message({
                message: '认证资料提交成功!'
                , type: 'success'
              })
              this.successDialog = true
              // 设置全局变量
              this.$store.commit('setNsrsbh', this.finalData.nsrsbh)
            } else {
              this.$message({
                message: data.errorMessage
                , type: 'warning'
              })
            }
          })
          .catch((data) => {
            this.ifLoading = false
            this.$message({
              message: '认证资料提交失败!请重试!'
              , type: 'warning'
            })
          })
      }

      , getFileFormData (files, type) {
        let formData = new FormData()
          , nameArr = []
          , idArr = []

        formData.append('fjlx', type)
        formData.append('rz_guid', this.guid)
        formData.append('UserName', this.$store.getters.getUserName)
        for (let i = 0; i < files.length; i++) {
          let item = files[i]
          formData.append('files', item.blob, item.name)
          nameArr.push(item.name)
          idArr.push(item.id)
        }
        // 设置name集合
        formData.append('fjmcls', JSON.stringify(nameArr))
        formData.append('id', JSON.stringify(idArr))

        return formData
      }

      // 提交成功弹窗关闭前调用
      , handleClose () {
        this.common.getDataCallback()
      }

      // 历史信息回填
      , initViewData (result, resultbg) {
        // 设置社会信用代码为只读
        this.nsrsbhDisabled = true
        // guid
        this.guid = result.rz_guid || this.$utils.randomString()
        // 纳税人识别号
        this.finalData.nsrsbh = result.nsrsbh || ''
        // 企业名称
        this.finalData.qymc = result.qymc || ''
        // 资质等级
        this.finalData.zzdj = result.zzdj || ''
        // 合同编号
        this.finalData.htbh = result.htbh || ''
        // 申请类型
        this.applyType = result.sqlx || '0'
        // 附件过滤
        for (let i = 0; i < resultbg.length; i++) {
          let item = resultbg[i]
            , cloneItem = this.$utils.deepClone(item)

          cloneItem.packSrc = cloneItem.path
          cloneItem.orgSrc = cloneItem.path
          cloneItem.loading = false
          if (item.leixing == 0) {
            this.businessFiles.push(cloneItem)
          } else if (item.leixing == 1) {
            this.contractFiles.push(cloneItem)
          }
        }
      }
    }
    , components: {
      ElCollapseTransition,
      HintInput,
      MultiImage,
    }
    , created () {
      // 如果存在历史结果
      if (this.common.result.nsrsbh) {
        this.initViewData(this.common.result, this.common.resultbg)
      }
    }
    , mounted () {
      let that = this
      // 营业执照
      that.businessUpload = Upload.init('.businessUp')
        .setMaxLimits(1)
        .setAllSize(8)
        .setDataList(that.businessFiles)
        .setBeforeDell(that.uploadBeforeDeal)
        .setAfterDeal(that.businessAfterDeal)
        .setError(that.uploadError)
      // 合同附件
      that.contractUpload = Upload.init('.contractUp')
        .setMaxLimits(10)
        .setAllSize(8)
        .setDataList(that.contractFiles)
        .setBeforeDell(that.uploadBeforeDeal)
        .setAfterDeal(that.contractAfterDeal)
        .setError(that.uploadError)
    }
    , watch: {
      businessFiles (newValue, oldValue) {
        if (newValue.length != 0) {
          this.businessMsgShow = false
        } else {
          this.businessMsgShow = true
        }
      }
      , contractFiles (newValue, oldValue) {
        if (newValue.length != 0) {
          this.contractMsgShow = false
        } else {
          this.contractMsgShow = true
        }
      }
    }
  }
</script>

<style scoped>
  p, div, input {
    overflow: hidden;
    transition: all .3s;
  }

  .show {
    padding-left: 345px;
    margin: 30px 0 16px;
    font-size: 13px;
    color: #949494;
    letter-spacing: 0;
  }

  .show-red {
    color: #FF665F;
  }

  .upLink {
    color: #04A4FF;
    text-decoration: underline;
  }

  .businessFileCon {
    margin-left: 417px;
    margin-top: 16px;
    height: 164px;
  }

  .contractFileCon {
    margin-left: 417px;
    margin-top: 16px;
    height: auto
  }

  .applyCon {
    position: relative;
    margin: 20px 0 24px;
    font-size: 14px;;
    line-height: 19px;
  }

  .commitBtn {
    width: 350px;
    height: 40px;
    margin: 40px auto 0;
    font-weight: 600;
    line-height: 40px;
    background: #5F93FF;
    border: 1px solid #3492FF;
    border-radius: 4px;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
  }

  .showText {
    display: inline-table;
    width: auto;
    height: 24px;
    padding-right: 8px;
    margin-left: 16px;
    line-height: 24px;
    background: #FFF2F2 url("../assets/error.png") no-repeat 7px center;
    border: 1px solid #FFE3E0;
    border-radius: 4px;
    font-size: 13px;
    color: #FF4D4D;
    letter-spacing: 0;
    text-indent: 26px;
  }

  .container >>> .el-dialog {
    height: 266px;
  }

  .dialogTitle {
    font-size: 24px;
    color: #5599FF;
    text-align: center;
    line-height: 58px;
    margin-top: 30px;
    font-weight: 600;
  }

  .dialogCon {
    font-size: 14px;
    color: #555555;
    letter-spacing: 0;
    text-align: center;
    line-height: 28px;
    margin: 16px 38px 0;
  }

  .dialogCon .workDay {
    font-size: 15px;
    color: #3492FF;
    letter-spacing: 0;
  }
</style>



// WEBPACK FOOTER //
// src/page/DataCommit.vue